<template>
  <div class="nav-container">
    <div
      class="nav-item"
      :class="{ 'nav-item-active': value == index }"
      v-for="(item, index) in commentTypeList"
      @click="bindChangeCommentType(index)"
      :key="index"
      >{{ item.name }}</div
    >
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      curActive: 0,
      commentTypeList: [
        {
          name: '营养师点评'
        },
        {
          name: 'AI点评'
        }
      ]
    }
  },
  created() {},
  methods: {
    bindChangeCommentType(index) {
      this.$emit('input', index)
    }
  }
}
</script>
<style lang="scss" scoped>
.nav-container {
  margin: 0 auto 10px;
  width: 314px;
  padding: 4px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: rgba(48, 48, 56, 0.1);
  border-radius: 21px;
  .nav-item {
    text-align: center;
    width: 153px;
    height: 34px;
    line-height: 34px;
    font-size: 16px;
    color: rgba(48, 48, 56, 0.8);
  }
  .nav-item-active {
    background: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(48, 48, 56, 0.09);
    border-radius: 17px;
    font-weight: bold;
    font-size: 16px;
    color: #303038;
  }
}
</style>
